import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline } from '@atlaskit/primitives/compiled';
import { PanelActionGroup } from '@atlassian/panel-system';

import type { PreviewPanelActionGroupProps } from './types';

export const PreviewPanelActionGroup = ({
	children,
	testId,
}: PreviewPanelActionGroupProps): React.JSX.Element => {
	if (fg('ads-panel-system-gpp')) {
		return <PanelActionGroup testId={testId}>{children}</PanelActionGroup>;
	}

	return (
		<Inline testId={testId} space="space.050" alignBlock="center">
			{children}
		</Inline>
	);
};
